import type { enStory } from './en.story';

export const caStory: typeof enStory = {
  story: {
    ui: {
      chapter: (n: number) => `Capítol ${n}`,
      locked: 'Avui no està disponible',
      progress: (done: number, total: number) => `${done}/${total}`,
      offers: 'té una cosa per a tu',
      talk: 'Parla amb',
    },
    items: {
      postcard: { name: 'Postal de Taipei', desc: 'Per a l’àvia Lee. Tres de diferents fan la col·lecció.' },
      pineappleCake: { name: 'Pastissets de pinya', desc: 'Una capsa de 鳳梨酥 de Taipei, per a la mare.' },
      mochi: { name: 'Mochi de Hualien', desc: 'Una capsa de 麻糬 tous per al Bo. Menja-te’ls avui!' },
      pebble: { name: 'Còdol de Qixingtan', desc: 'Rodó i gris, polit pel Pacífic. Per a la Rain.' },
      photo: { name: 'Foto des de la Muntanya de l’Elefant', desc: 'Tu i el Taipei 101. Per a l’Emma.' },
    },
    chapters: {
      school: { title: 'Primer dia de tornada', hint: 'Divendres a l’insti: amics, profes i un conserge que s’ha saltat l’esmorzar.' },
      town: { title: 'Cap de setmana al barri', hint: 'Dissabte i diumenge pel poble: gatets perduts, estels i trèvols de la sort.' },
      taipei: { title: 'Postals de Taipei', hint: 'Agafa el tren a l’estació. La ciutat té encàrrecs per a tu a cada districte.' },
      hualien: { title: 'Vent del Pacífic', hint: 'El tren cap a l’est arriba a Hualien: congostos de marbre, platges de còdols i mochi enganxós.' },
    },
    quests: {
      postcards: {
        offer: 'De jove mai no vaig poder veure la gran ciutat. Em portaries postals de Taipei? Una de l’estació, una del temple de Longshan i una de la Plaça de la Llibertat.',
        accept: 'Et portaré tres postals!',
        collect: {
          guide: 'Una postal de l’Estació Central de Taipei: el gran vestíbul de maó vermell de 1941. Mira, fins i tot hi ha el rellotge.',
          xm_volunteer: 'Una postal del temple de Longshan. Sabies que el van construir el 1738 colons vinguts de Fujian?',
          ck_guide: 'Una postal de la porta blanca de la Plaça de la Llibertat. Els seus cinc arcs fan 30 metres!',
        },
        ask: 'Em donaria una postal per a la meva àvia?',
        give: 'Donar a l’àvia les tres postals',
        thanks: 'Ai… l’estació, el temple, la gran porta. És com si hagués viatjat amb tu. Gràcies, rei.',
      },
      pineapple: {
        offer: 'L’àvia ve a berenar i li encanten els pastissets de pinya 鳳梨酥. Els millors són a Taipei: me’n portaries una capsa si hi vas?',
        accept: 'Portaré una capsa de pastissets de pinya!',
        buy: 'Comprar una capsa de pastissets de pinya (60🪙)',
        bought: 'Acabats de sortir del forn! Massa de mantega i melmelada de pinya a dins. Porta la capsa plana.',
        poor: 'La capsa val 60 monedes. Torna quan en tinguis prou!',
        give: 'Donar a la mare els pastissets de pinya',
        thanks: 'Pastissets de pinya de Taipei de debò! L’àvia estarà contentíssima. Ets una estrella.',
      },
      elephant: {
        offer: 'Tothom a l’escola té una foto del Taipei 101 des de la Muntanya de l’Elefant. Me’n fas una? Sisplaaau!',
        accept: 'Hi pujaré i faré la foto!',
        ask: 'Em fa una foto amb el Taipei 101?',
        shot: 'Lluís! …Perfecta: tot l’skyline darrere teu. 600 graons ben invertits.',
        give: 'Ensenyar a l’Emma la foto des de la Muntanya de l’Elefant',
        thanks: 'UAU! La ciutat sencera! La poso a la nevera. Ets el millor!',
      },
      mochi: {
        offer: 'El meu cosí diu que el mochi 麻糬 de Hualien és la cosa més tova del món. Si hi vas… me’n portes? Et canvio la meva millor bala.',
        accept: 'Tracte fet. Mochi de Hualien, de seguida!',
        buy: 'Comprar una capsa de mochi per al Bo (40🪙)',
        bought: 'Picat aquest matí: mongeta mungo, sèsam i cacauet. Menja-te’ls avui, que no aguanten!',
        poor: 'La capsa val 40 monedes, jovenet. Estalvia i torna!',
        give: 'Donar al Bo el mochi de Hualien',
        thanks: 'Que TOUS! Té, la bala: és teva. El millor canvi de la història.',
      },
      pebble: {
        offer: 'Col·lecciono pedres de tot Taiwan. Em falta un còdol gris i rodó de la platja de Qixingtan, a Hualien. Me’n trobaries un?',
        accept: 'Un còdol de Qixingtan. El trobaré!',
        ask: 'Puc endur-me un còdol per a la col·lecció d’una amiga?',
        found: 'Un? D’acord, però només un, i digues a la teva amiga que la platja necessita la resta. El mar l’ha polit durant mil anys.',
        give: 'Donar a la Rain el còdol de Qixingtan',
        thanks: 'Rodó, gris, suau com el vidre… és perfecte. Qixingtan, fet! Gràcies!',
      },
    },
  },
};
